import { defineStore } from 'pinia';
import { type ComputedRef, computed } from 'vue';

interface IStaticPagesStore {
  page: string;
  fragments: Record<string, string>;
}

export const useStaticPages = defineStore('static-pages', {
  state: () => ({
    page: '',
    fragments: {},
  }) as IStaticPagesStore,

  getters: {
    getFragment(state) {
      return (fragmentName: string): string => state.fragments[fragmentName] || '';
    },
    // Для загрузки блоков которые приходят не сразу
    getComputedFragment(state) {
      return (fragmentName: string): ComputedRef<string> => computed(() => state.fragments[fragmentName] || '');
    },
  },
});
